export type CacheProfile = "bounded" | "unbounded";

export const CACHE_PROFILE_QUERY_PARAM = "cacheProfile";
export const CACHE_PROFILE_STORAGE_KEY = "metx:cache-profile";
export const DEFAULT_CACHE_PROFILE: CacheProfile = "bounded";
export const UNBOUNDED_CACHE_LIMIT = Number.MAX_SAFE_INTEGER;

function parseCacheProfile(value: string | null | undefined): CacheProfile | null {
  if (value === "bounded" || value === "unbounded") {
    return value;
  }

  return null;
}

export function resolveCacheProfile(
  args: {
    search?: string | null;
    persistedValue?: string | null;
    envValue?: string | null;
  } = {},
): CacheProfile {
  const queryValue = args.search ? new URLSearchParams(args.search).get(CACHE_PROFILE_QUERY_PARAM) : null;

  return (
    parseCacheProfile(queryValue) ??
    parseCacheProfile(args.persistedValue) ??
    parseCacheProfile(args.envValue) ??
    DEFAULT_CACHE_PROFILE
  );
}

export function getCacheProfile(): CacheProfile {
  if (typeof window === "undefined") {
    return resolveCacheProfile({ envValue: process.env.REACT_APP_CACHE_PROFILE });
  }

  let persistedValue: string | null = null;
  try {
    persistedValue = window.localStorage.getItem(CACHE_PROFILE_STORAGE_KEY);
  } catch {}

  return resolveCacheProfile({
    search: window.location.search,
    persistedValue,
    envValue: process.env.REACT_APP_CACHE_PROFILE,
  });
}

export function cacheLimit(limit: number, profile: CacheProfile = getCacheProfile()): number {
  return profile === "bounded" ? limit : UNBOUNDED_CACHE_LIMIT;
}

export function isCacheEvictionEnabled(profile: CacheProfile = getCacheProfile()): boolean {
  return profile === "bounded";
}

export function persistCacheProfile(profile: CacheProfile): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(CACHE_PROFILE_STORAGE_KEY, profile);
  } catch {}
}
